/**
 * Theme Constants
 * Centralized colors, spacing, and breakpoints for consistent styling
 */

// Color Palette
export const COLORS = {
  // Primary brand colors
  primary: '#007bff',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',

  // Neutral colors
  white: '#ffffff',
  black: '#000000',

  // Gray scale
  gray: {
    50: '#f8f9fa',
    100: '#f5f5f5',
    200: '#f0f0f0',
    300: '#e0e0e0',
    400: '#ddd',
    500: '#999',
    600: '#666',
    700: '#333',
    800: '#212529',
  },

  // Semantic colors for backgrounds
  background: {
    default: '#f5f5f5',
    card: '#ffffff',
    modal: 'rgba(0,0,0,0.5)',
  },

  // Status badge colors
  badge: {
    hitting: { bg: '#e3f2fd', text: '#1976d2' },
    catching: { bg: '#f3e5f5', text: '#7b1fa2' },
    fielding: { bg: '#e8f5e9', text: '#388e3c' },
    pitching: { bg: '#fff3e0', text: '#f57c00' },
    beginner: { bg: '#e8f5e9', text: '#388e3c' },
    intermediate: { bg: '#fff3e0', text: '#f57c00' },
    advanced: { bg: '#ffebee', text: '#d32f2f' },
    pending: { bg: '#fff3e0', text: '#f57c00' },
    completed: { bg: '#e8f5e9', text: '#388e3c' },
  },

  // Alert/notification colors
  alert: {
    error: {
      bg: '#fee',
      text: '#c33',
      border: '#fcc',
    },
    success: {
      bg: '#efe',
      text: '#3c3',
      border: '#cfc',
    },
  },
};

// Responsive Breakpoints
export const BREAKPOINTS = {
  mobile: 768, // 0-767px
  tablet: 1024, // 768-1023px
  desktop: 1024, // 1024px+
};

// Spacing Scale (in pixels)
export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '30px',
  xxxl: '40px',
};

// Typography
export const FONT_SIZE = {
  xs: '11px',
  sm: '12px',
  md: '13px',
  base: '14px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
};

export const FONT_WEIGHT = {
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
};

// Border Radius
export const BORDER_RADIUS = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  full: '9999px',
};

// Shadows
export const SHADOWS = {
  sm: '0 1px 2px rgba(0,0,0,0.05)',
  md: '0 2px 4px rgba(0,0,0,0.1)',
  lg: '0 4px 6px rgba(0,0,0,0.1)',
  xl: '0 10px 15px rgba(0,0,0,0.1)',
};

// Touch Target Sizes (for mobile)
export const TOUCH_TARGET = {
  minimum: '44px', // iOS/Android recommended minimum
};

// Z-Index Scale
export const Z_INDEX = {
  dropdown: 100,
  sticky: 200,
  modal: 1000,
  tooltip: 1100,
};

// Transitions
export const TRANSITIONS = {
  fast: '0.15s ease',
  base: '0.2s ease',
  slow: '0.3s ease',
};
